// p2p multi-address code
export const CODE_P2P = 421;
export const CODE_CIRCUIT = 290;
export const CODE_TCP = 6;
export const CODE_WS = 477;
export const CODE_WSS = 478;
// Time to wait for a connection to close gracefully before destroying it manually
export const CLOSE_TIMEOUT = 500;
//# sourceMappingURL=constants.js.map